"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var auth0_react_1 = require("@auth0/auth0-react");
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var hooks_1 = require("../../hooks");
var actions_1 = require("../../modules/categories/actions");
var hooks_2 = require("../../modules/categories/hooks");
var hooks_3 = require("../../modules/stations/hooks");
var utils_1 = require("../../utils");
var CategoryIcon_1 = __importDefault(require("./CategoryIcon"));
var CategoryListView = react_1.default.memo(function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, hooks_1.useAppDispatch)();
    var getAccessTokenSilently = (0, auth0_react_1.useAuth0)().getAccessTokenSilently;
    var _a = (0, hooks_2.useCategories)(), initialFetchDone = _a.initialFetchDone, isFetching = _a.isFetching, categories = _a.items;
    var _b = (0, hooks_3.useStations)(), stations = _b.items, stationsFetching = _b.isFetching, initialStationFetchDone = _b.initialFetchDone;
    var categoryTableItems = (0, react_1.useMemo)(function () { return categories.map(function (s) { return (__assign(__assign({}, s), { stations: stations.filter(function (station) { return station.category === s.id; }) })); }); }, [categories, stations]);
    var _c = (0, react_1.useState)(null), delCategory = _c[0], setDelCategory = _c[1];
    var onAdd = (0, react_1.useCallback)(function () { return navigate("../add"); }, [navigate]);
    var extra = (0, react_1.useMemo)(function () { return [
        react_1.default.createElement(antd_1.Button, { key: "add", type: "primary", icon: react_1.default.createElement(icons_1.PlusOutlined, null), onClick: onAdd }, "Add New"),
    ]; }, [onAdd]);
    var columns = (0, react_1.useMemo)(function () { return [
        {
            title: "ID",
            dataIndex: "id",
        },
        {
            title: "Icon",
            dataIndex: "icon_svg",
            render: function (path) { return path ? react_1.default.createElement(CategoryIcon_1.default, { path: path }) : null; },
        },
        {
            title: "Actions",
            key: "actions",
            width: 200,
            render: function (category) { return (react_1.default.createElement(antd_1.Space, { size: "small" },
                react_1.default.createElement(antd_1.Button, { icon: react_1.default.createElement(icons_1.EditOutlined, null), onClick: function () { return navigate("../edit/".concat(category.id)); } }, "Edit"),
                react_1.default.createElement(antd_1.Button, { icon: react_1.default.createElement(icons_1.DeleteOutlined, null), danger: true, onClick: function () { return setDelCategory(category); }, disabled: (!initialStationFetchDone && stationsFetching) || category.stations.length > 0 }, "Delete"))); }
        },
    ]; }, [navigate, initialStationFetchDone, stationsFetching]);
    var closeDelModal = (0, react_1.useCallback)(function () { return setDelCategory(null); }, []);
    var onDelete = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var token, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!delCategory)
                        return [2 /*return*/];
                    if (delCategory.stations.length)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, getAccessTokenSilently(utils_1.ACCESS_TOKEN_MANAGE)];
                case 2:
                    token = _a.sent();
                    return [4 /*yield*/, dispatch((0, actions_1.deleteCategory)(delCategory.id, token))];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    console.error(e_1);
                    return [3 /*break*/, 5];
                case 5:
                    closeDelModal();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, getAccessTokenSilently, delCategory]);
    return react_1.default.createElement(antd_1.PageHeader, { ghost: false, title: "Categories", subTitle: "View station categories", extra: extra },
        react_1.default.createElement(antd_1.Modal, { title: "Delete category: ".concat(delCategory === null || delCategory === void 0 ? void 0 : delCategory.id), open: !!delCategory, onCancel: closeDelModal, footer: react_1.default.createElement(antd_1.Space, null,
                react_1.default.createElement(antd_1.Button, { type: "primary", danger: true, icon: react_1.default.createElement(icons_1.DeleteOutlined, null), onClick: onDelete }, "Delete"),
                react_1.default.createElement(antd_1.Button, { onClick: closeDelModal }, "Cancel")) },
            "Are you sure you wish to delete the category \u201C", delCategory === null || delCategory === void 0 ? void 0 :
            delCategory.id,
            "\u201D?"),
        react_1.default.createElement(antd_1.Table, { bordered: true, size: "small", loading: !initialFetchDone && isFetching, columns: columns, dataSource: categoryTableItems, rowKey: "id", pagination: false }));
});
exports.default = CategoryListView;
